export default __webpack_public_path__ + "static/media/A-graphic-extralarge.1ecc8657.svg";